/* eslint-disable no-await-in-loop */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { HiPlus } from 'react-icons/hi';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';

import { AiOutlineMail } from 'react-icons/ai';
import Swal from 'sweetalert2';
import api from '~/services/api';
import getValidationErros from '~/utils/getValidationsErrors';
import { useAuth } from '~/hooks/Auth';

import {
  Container,
  Modal,
  TableListModal,
  ModalityContainer,
  CategoryItem,
  Filter,
} from './styles';
import Select, { IOption } from '~/components/Select';
import InfiniteScroll from '~/components/InfiniteScroll';

import Loading from '~/components/Loading';
import KrClose from '~/components/KoroIcons/KrClose';
import Input from '~/components/Input';
import Toast from '~/utils/toast';
import Card from './Card';

import Table, { IColumn } from '~/components/Table';
import { IBatchCategories } from '../Events/ManageEvent/Interfaces';
import formatDate from '~/utils/formatDate';
import FiltersLists from '~/components/FiltersLists';

const POLLING_TIMEOUT_MS = 2 * 60 * 1000;

export interface ICourtesyBatch {
  id: number;
  archive_url: string;
  order_id: number;
  name: string;
  created_at: string;
  event_id: number;
  event_name: string;
  status: string;
  quantity: number;
  used_quantity: number;
}

interface ICourtesyTicket {
  id: number;
  ticket_number: string;
  event_name: string;
  modality_name: string;
  category_name: string;
  email: string;
}

interface IModalityData {
  id: number;
  name: string;
  order?: number;
  categories: {
    id: number;
    name: string;
    batch_id?: number;
    batch_category_id?: number;
    available: number;
    order?: number;
  }[];
}

const Courtesy: React.FC = () => {
  const { user } = useAuth();
  const formRefCourtesy = useRef<FormHandles>(null);
  const formRefEmail = useRef<FormHandles>(null);

  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [timedOutIds, setTimedOutIds] = useState<number[]>([]);
  const pollTimers = useRef<Record<number, ReturnType<typeof setTimeout>>>({});
  const pollStarts = useRef<Record<number, number>>({});
  const [modalCourtesy, setModalCourtesy] = useState(false);
  const [modalList, setModalList] = useState(false);
  const [modalEmail, setModalEmail] = useState(false);

  const [eventsModal, setEventsModal] = useState<IOption[]>([]);
  const [eventsList, setEventsList] = useState<any[]>([]);
  const [eventName, setEventName] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState(eventName);

  const [organizerId, setOrganizerId] = useState<number | null>(null);
  const [selectedEventId, setSelectedEventId] = useState<number | null>(null);
  const [selectedEventImage, setSelectedEventImage] = useState('');
  const [modalities, setModalities] = useState<IModalityData[]>([]);
  const [quantities, setQuantities] = useState<Record<string, number>>({});

  const [courtesyList, setCourtesyList] = useState<ICourtesyBatch[]>([]);
  const [ticketList, setTicketList] = useState<ICourtesyTicket[]>([]);
  const [selectedTicket, setSelectedTicket] = useState<ICourtesyTicket | null>(
    null
  );
  const [selectedCourtesyId, setSelectedCourtesyId] = useState<number | null>(
    null
  );
  const [organizerUsersIds, setOrganizerUsersIds] = useState<number[]>([]);
  const [isOrganizerOrder, setIsOrganizerOrder] = useState(true);
  const [erroEvent, setErroEvent] = useState('');
  const [erroQtdTicket, setErroQtdTicket] = useState('');
  const [statusFilter, setStatusFilter] = useState<string | undefined>('');
  const [eventFilter, setEventFilter] = useState<string | undefined>('');
  const [loadingMore, setLoadingMore] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const status = useMemo(
    () => [
      {
        id: 'Em andamento',
        value: 'Em andamento',
        selected: false,
      },
      {
        id: 'Encerrado',
        value: 'Encerrado',
        selected: false,
      },
      {
        id: 'Gerando',
        value: 'Gerando',
        selected: false,
      },
    ],
    []
  );

  // subir

  useEffect(() => {
    console.log({ organizerId });
    if (organizerId) {
      api.get(`organizers/${organizerId}`).then((response) => {
        const userIds = response.data.organizersUsers.map(
          (organizerUser: any) => organizerUser.user_id
        );
        setOrganizerUsersIds(userIds);
      });
    }
  }, [organizerId]);

  const loadCourtesyList = useCallback(
    async (
      pageData = 1,
      statusData?: string,
      event?: string,
      silent = false
    ) => {
      try {
        if (!silent) setLoading(true);
        const response = await api.get('courtesies', {
          params: {
            page: pageData,
            status: statusData,
            event,
          },
        });

        const data = response.data.data.map((item: any) => ({
          id: item.id,
          archive_url: item.archive_url,
          order_id: `${formatDate(item.order_date, 'yyyyMMddHHmm')}00${
            item.order_id
          }`,
          name: item.name,
          created_at: item.date,
          event_id: item.event_id,
          event_name: item.event_name || '-',
          status: item.status,
          quantity: item.qty_total,
          used_quantity: item.qty_used,
        }));

        if (pageData === 1) {
          setCourtesyList(data);
        } else {
          setCourtesyList((oldState) => [...oldState, ...data]);
        }

        setTotalPages(response.data.pages);

        // Load organizer users if we have courtesies
        if (
          response.data.data.length > 0 &&
          response.data.data[0].organizer_id
        ) {
          setOrganizerId(response.data.data[0].organizer_id);
        }
      } catch (error) {
        console.log(error);
      } finally {
        if (!silent) setLoading(false);
      }
    },
    []
  );

  useEffect(() => {
    loadCourtesyList();
  }, [loadCourtesyList]);

  const stopPolling = useCallback((id: number) => {
    clearTimeout(pollTimers.current[id]);
    delete pollTimers.current[id];
    delete pollStarts.current[id];
  }, []);

  const pollCourtesyStatus = useCallback(
    (id: number, attempt = 0) => {
      if (pollStarts.current[id] === undefined) {
        pollStarts.current[id] = Date.now();
      }

      if (Date.now() - pollStarts.current[id] > POLLING_TIMEOUT_MS) {
        stopPolling(id);
        setTimedOutIds((prev) => (prev.includes(id) ? prev : [...prev, id]));
        return;
      }

      const delay = Math.min(2000 + attempt * 500, 8000);

      pollTimers.current[id] = setTimeout(async () => {
        try {
          const { data } = await api.get(`courtesies/${id}/status`);

          if (data.generating) {
            pollCourtesyStatus(id, attempt + 1);
            return;
          }

          stopPolling(id);
          setCourtesyList((prev) =>
            prev.map((c) =>
              c.id === id
                ? {
                    ...c,
                    status: data.status,
                    quantity: data.total_tickets ?? c.quantity,
                  }
                : c
            )
          );

          if (data.failed) {
            Swal.fire({
              title: 'Não foi possível gerar as inscrições desta cortesia',
              text: 'Nenhuma inscrição foi criada. Tente novamente criando uma nova cortesia.',
              icon: 'error',
              iconColor: '#F00',
              confirmButtonColor: '#ff6900',
            });
          } else {
            Toast.fire({
              title: `Cortesia "${data.name}" gerada com sucesso`,
              icon: 'success',
              iconColor: '#ff6900',
            });
            loadCourtesyList(1, undefined, undefined, true);
          }
        } catch (error) {
          // Falha pontual (ex.: rede): tenta novamente sem avisar o usuário
          pollCourtesyStatus(id, attempt + 1);
        }
      }, delay);
    },
    [loadCourtesyList, stopPolling]
  );

  const generatingIdsKey = courtesyList
    .filter((c) => c.status === 'Gerando')
    .map((c) => c.id)
    .join(',');

  useEffect(() => {
    if (!generatingIdsKey) return;

    generatingIdsKey.split(',').forEach((idStr) => {
      const id = Number(idStr);
      if (pollTimers.current[id] === undefined && !timedOutIds.includes(id)) {
        pollCourtesyStatus(id);
      }
    });
  }, [generatingIdsKey, timedOutIds, pollCourtesyStatus]);

  useEffect(() => {
    const timers = pollTimers.current;
    return () => {
      Object.values(timers).forEach((timer) => clearTimeout(timer));
    };
  }, []);

  const generatingCourtesies = useMemo(
    () => courtesyList.filter((c) => c.status === 'Gerando'),
    [courtesyList]
  );

  const handleLoadEventsModal = useCallback(async (search = '') => {
    try {
      const response = await api.get('events/organizer', {
        params: {
          search: search.trim(),
          status_ids: [3, 4, 5],
        },
      });

      const data = response.data.map((event: any) => ({
        id: event.id,
        value: event.name,
        selected: false,
      }));

      setOrganizerId(response.data[0].organizer_id);
      setEventsList(response.data);
      setEventsModal(data);
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    if (modalCourtesy) {
      handleLoadEventsModal(debouncedSearch);
    }
  }, [debouncedSearch, handleLoadEventsModal, modalCourtesy]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(eventName);
    }, 500);

    return () => clearTimeout(timer);
  }, [eventName]);

  const handleSelectEvent = useCallback(
    async (event: IOption) => {
      setEventName(event.value);
      setSelectedEventId(Number(event.id));

      const selectedEvent = eventsList.find((e) => e.id === Number(event.id));
      if (
        selectedEvent &&
        selectedEvent.archivesEvents &&
        selectedEvent.archivesEvents.length > 0
      ) {
        setSelectedEventImage(
          selectedEvent.archivesEvents[0].archive.archive_url
        );
      } else {
        setSelectedEventImage('');
      }

      try {
        const response = await api.get(`events/${selectedEvent.slug}`);

        const modalityMap = new Map<number, IModalityData>();

        const sortedBatches = (response.data.batchesCategories || [])
          .filter(
            (batchCategory: any) =>
              batchCategory.batch_id === response.data.batch_id
          )
          .sort((a: any, b: any) => (a.batch_id || 0) - (b.batch_id || 0));

        sortedBatches.forEach((item: IBatchCategories) => {
          if (!modalityMap.has(item.modality.id)) {
            modalityMap.set(item.modality.id, {
              id: item.modality.id,
              name: item.modality.name,
              categories: [],
            });
          }

          const modality = modalityMap.get(item.modality.id);
          if (modality) {
            const batchQty = item.batch?.quantity || 0;
            const batchSold = item.batch?.quantity_sold || 0;
            const itemQty = item.quantity || 0;
            const itemSold = item.quantity_sold || 0;

            let available = 0;

            if (batchQty === 0 && itemQty === 0) {
              available = Infinity;
            } else {
              const limit = itemQty > 0 ? itemQty : batchQty;
              const sold = itemQty > 0 ? itemSold : batchSold;
              available = limit - sold;
            }

            const existingIndex = modality.categories.findIndex(
              (c) => c.id === item.category.id
            );

            if (existingIndex === -1) {
              modality.categories?.push({
                id: item.category.id,
                name: item.category.name,
                batch_id: item.batch_id,
                batch_category_id: item.id,
                available,
              });
            } else {
              const existing = modality.categories[existingIndex];
              if (existing.available <= 0 && available > 0) {
                modality.categories[existingIndex] = {
                  id: item.category.id,
                  name: item.category.name,
                  batch_id: item.batch_id,
                  batch_category_id: item.id,
                  available,
                };
              }
            }
          }
        });

        const modalitiesData: IModalityData[] = Array.from(
          modalityMap.values()
        );

        setModalities(modalitiesData);
      } catch (error) {
        console.log(error);
        setModalities([]);
      }
    },
    [eventsList]
  );

  const handleChangeTextEvent = useCallback((text) => {
    setEventName(text);
  }, []);

  const handleQuantityChange = useCallback(
    (modalityId: number, categoryId: number, value: string) => {
      setQuantities((prev) => ({
        ...prev,
        [`${modalityId}-${categoryId}`]: Number(value),
      }));
    },
    []
  );

  const handleCloseModalCourtesy = useCallback(() => {
    setModalCourtesy(false);
    setErroEvent('');
    setEventName('');
    setSelectedEventId(null);
  }, []);

  const handleSubmitCourtesy = useCallback(
    async (data: { name: string }) => {
      try {
        setSubmitting(true);
        formRefCourtesy.current?.setErrors({});

        const schema = Yup.object().shape({
          name: Yup.string().required('Nome é obrigatório'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        if (!selectedEventId) {
          setErroEvent('Selecione um evento');
          return;
        }
        setErroEvent('');

        // Filter quantities > 0
        const items = Object.entries(quantities)
          .filter(([_, qty]) => qty > 0)
          .map(([key, qty]) => {
            const [modalityId, categoryId] = key.split('-');
            const modality = modalities.find(
              (m) => m.id === Number(modalityId)
            );
            const category = modality?.categories.find(
              (c) => c.id === Number(categoryId)
            );

            return {
              batch_category_id: category?.batch_category_id,
              quantity: Math.floor(qty),
            };
          })
          .filter((item) => !!item.batch_category_id && item.quantity >= 1);

        if (items.length === 0) {
          setErroQtdTicket('Coloque ao menos uma quantidade de inscrição');
          return;
        }
        setErroQtdTicket('');

        await api.post('courtesies', {
          event_id: selectedEventId,
          name: data.name,
          items,
        });

        setQuantities({});
        handleCloseModalCourtesy();
        setModalities([]);

        // A nova cortesia vem com status "Gerando" e o polling é iniciado
        await loadCourtesyList(1, undefined, undefined, true);
      } catch (err) {
        console.log(err);
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErros(err);
          formRefCourtesy.current?.setErrors(errors);
          return;
        }
        const apiMessage = (err as any)?.response?.data?.message;
        Toast.fire({
          title:
            typeof apiMessage === 'string' && apiMessage
              ? apiMessage
              : 'Erro ao criar cortesia',
          icon: 'error',
          iconColor: '#F00',
        });
      } finally {
        setSubmitting(false);
      }
    },
    [
      selectedEventId,
      quantities,
      loadCourtesyList,
      modalities,
      handleCloseModalCourtesy,
    ]
  );

  const handleOpenList = useCallback(
    async (id: number) => {
      try {
        setSelectedCourtesyId(id);
        const response = await api.get(`tickets/courtesies/${id}`);

        const generatedTickets: ICourtesyTicket[] = [];

        const isOrgOrder = organizerUsersIds.includes(response.data[0].user_id);
        setIsOrganizerOrder(isOrgOrder);

        response.data.forEach((ticket: any) => {
          generatedTickets.push({
            id: ticket.id,
            event_name: ticket.event_name || '-',
            ticket_number: ticket.code,
            modality_name: ticket.modality_name || 'N/A',
            category_name: ticket.category_name || 'N/A',
            email: ticket.email || '',
          });
        });

        setTicketList(generatedTickets);
        setModalList(true);
      } catch (error) {
        console.log(error);
        Toast.fire({
          title: 'Erro ao carregar Inscrições',
          icon: 'error',
          iconColor: '#F00',
        });
      }
    },
    [organizerUsersIds]
  );

  const handleOpenEmail = useCallback((ticket: ICourtesyTicket) => {
    setSelectedTicket(ticket);
    setModalEmail(true);
  }, []);

  const handleOpenEmailAll = useCallback(() => {
    setSelectedTicket(null);
    setModalEmail(true);
  }, []);

  const handleSubmitEmail = useCallback(
    async (data: { email: string }) => {
      try {
        setLoading(true);
        formRefEmail.current?.setErrors({});

        const schema = Yup.object().shape({
          email: Yup.string()
            .required('E-mail obrigatório')
            .email('Digite um e-mail válido'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        if (!selectedCourtesyId) {
          Toast.fire({
            title: 'Erro ao identificar a cortesia',
            icon: 'error',
            iconColor: '#F00',
          });
          return;
        }

        if (selectedTicket) {
          // Assign single ticket
          await api.post(
            `courtesies/${selectedCourtesyId}/tickets/${selectedTicket.id}/assign`,
            {
              email: data.email,
            }
          );
        } else {
          // Assign all tickets (courtesy)
          await api.post(`courtesies/${selectedCourtesyId}/assign`, {
            email: data.email,
          });
        }

        Toast.fire({
          title: 'Email enviado com sucesso',
          icon: 'success',
          iconColor: '#ff6900',
        });

        setModalEmail(false);
        // Update ticket list locally
        if (selectedTicket) {
          setTicketList((prev) =>
            prev.map((t) =>
              t.id === selectedTicket.id ? { ...t, email: data.email } : t
            )
          );
          // Atualiza Qtd Usados +1 na cortesia correspondente
          setCourtesyList((prev) =>
            prev.map((c) =>
              c.id === selectedCourtesyId
                ? {
                    ...c,
                    used_quantity: Math.min(
                      (c.used_quantity || 0) + 1,
                      c.quantity
                    ),
                  }
                : c
            )
          );
        } else {
          setTicketList((prev) =>
            prev.map((t) => ({ ...t, email: data.email }))
          );
          // Atualiza Qtd Usados = Qtd inscrições na cortesia correspondente
          setCourtesyList((prev) =>
            prev.map((c) =>
              c.id === selectedCourtesyId
                ? { ...c, used_quantity: c.quantity }
                : c
            )
          );
        }
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErros(err);
          formRefEmail.current?.setErrors(errors);
          return;
        }
        Toast.fire({
          title: 'Erro ao enviar email',
          icon: 'error',
          iconColor: '#F00',
        });
      } finally {
        setLoading(false);
      }
    },
    [selectedTicket, selectedCourtesyId]
  );

  const columnsTickets = useMemo<IColumn[]>(
    () => [
      {
        name: 'Num da Inscrição',
        selector: 'ticket_number',
        sortable: true,
      },

      {
        name: 'Modalidade',
        selector: 'modality_name',
        sortable: true,
        cell: (row: ICourtesyTicket) => (
          <span title={row.modality_name}>{row.modality_name}</span>
        ),
      },
      {
        name: 'Categoria',
        selector: 'category_name',
        sortable: true,
        cell: (row: ICourtesyTicket) => (
          <span title={row.category_name}>{row.category_name}</span>
        ),
      },
      {
        name: 'Email',
        selector: 'email',
        sortable: true,
        cell: (row: ICourtesyTicket) => (
          <span title={row.email}>{row.email}</span>
        ),
      },
      {
        name: '',
        cell: (row: ICourtesyTicket) => (
          <button
            type="button"
            className="btn-icons border-0"
            onClick={() => handleOpenEmail(row)}
            disabled={!isOrganizerOrder || !!row.email}
            style={{ opacity: !isOrganizerOrder || !!row.email ? 0.5 : 1 }}
          >
            <AiOutlineMail size={20} color="#fff" />
          </button>
        ),
      },
    ],
    [handleOpenEmail, isOrganizerOrder]
  );

  const isAnyQuantityExceeded = useMemo(() => {
    return modalities.some((modality) =>
      modality.categories.some((category) => {
        const currentQty = quantities[`${modality.id}-${category.id}`] || 0;
        return currentQty > category.available;
      })
    );
  }, [modalities, quantities]);

  const handleSubmitFilters = useCallback(
    (formData) => {
      const newStatus =
        formData.statusCourtesy !== 'todos'
          ? formData.statusCourtesy
          : undefined;
      const newEvent = formData.event === 'Todos' ? undefined : formData.event;

      setStatusFilter(newStatus);
      setEventFilter(newEvent);
      setPage(1);

      loadCourtesyList(1, newStatus, newEvent);
    },
    [loadCourtesyList]
  );

  const handleDeleteCourtesy = useCallback(async (id: number) => {
    try {
      Swal.fire({
        title: 'Gostaria de encerrar a cortesia?',
        icon: 'warning',
        iconColor: '#ff6900',
        showCancelButton: true,
        cancelButtonText: 'Não',
        confirmButtonText: 'Sim',
        confirmButtonColor: '#ff6900',
        cancelButtonColor: '#B34A00',
        reverseButtons: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          await api.put(`courtesies/${id}`, { status: 'Encerrado' });
          setCourtesyList((prev) =>
            prev.map((courtesy) =>
              courtesy.id === id
                ? {
                    ...courtesy,
                    status: 'Encerrado',
                  }
                : courtesy
            )
          );
          Swal.fire({
            title: 'Cortesia encerrada com sucesso',
            icon: 'success',
            iconColor: '#ff6900',
          });
        }
      });
    } catch (err) {
      Swal.fire({
        title: 'Erro ao encerrar cortesia',
        icon: 'error',
        iconColor: '#F00',
      });
    }
  }, []);

  const handleLoad = useCallback(async () => {
    if (loadingMore) return;

    if (page < totalPages) {
      setLoadingMore(true);
      const nextPage = page + 1;

      await loadCourtesyList(nextPage, statusFilter, eventFilter);
      setPage(nextPage);

      setLoadingMore(false);
    }
  }, [
    loadingMore,
    page,
    totalPages,
    loadCourtesyList,
    statusFilter,
    eventFilter,
  ]);

  return (
    <Container className="mt-0 mb-3">
      <InfiniteScroll
        id="infinite-scroll"
        onInfiniteLoad={handleLoad}
        className="infinite-scroll py-3"
      >
        <div className="container-fluid">
          <div className="row">
            <div className="zoom col-12 px-0">
              <div className="bg-white d-flex justify-content-between align-items-center p-4">
                <h1 className="mb-0">Inscrições de Cortesia</h1>
                <div>
                  <button
                    type="button"
                    className="mb-0 h6 fw-normal text-white btn-new px-5 py-2 d-flex align-items-center"
                    onClick={() => setModalCourtesy(true)}
                  >
                    <HiPlus size={16} color="#fff" className="me-2" />
                    Gerar Cortesia
                  </button>
                </div>
              </div>
            </div>
            <Filter className="col-12 px-0 mt-3">
              <FiltersLists
                onSubmitFilters={handleSubmitFilters}
                event
                statusCourtesy
                statusOptions={status}
              />
            </Filter>

            {generatingCourtesies.length > 0 && (
              <div className="col-12 mt-3">
                {generatingCourtesies.map((courtesy) => (
                  <div
                    key={courtesy.id}
                    className="bg-white p-3 mb-2"
                    role="status"
                  >
                    {timedOutIds.includes(courtesy.id) ? (
                      <p className="mb-0">
                        <strong>{courtesy.name}:</strong> A geração continua em
                        segundo plano, acompanhe na lista de cortesias.
                      </p>
                    ) : (
                      <>
                        <p className="mb-2">
                          Gerando cortesia: <strong>{courtesy.name}</strong>
                        </p>
                        <div className="progress" style={{ height: 6 }}>
                          <div
                            className="progress-bar progress-bar-striped progress-bar-animated"
                            style={{
                              width: '100%',
                              backgroundColor: '#ff6900',
                            }}
                          />
                        </div>
                      </>
                    )}
                  </div>
                ))}
              </div>
            )}

            <div className="zoom col-12 mt-3">
              {courtesyList.map((courtesy) => (
                <Card
                  key={courtesy.id}
                  courtesy={courtesy}
                  onViewTickets={handleOpenList}
                  onDeleteCourtesy={handleDeleteCourtesy}
                />
              ))}
            </div>
          </div>
        </div>
      </InfiniteScroll>
      <Loading text="Aguarde..." active={loading} />

      {/* Modal Create Courtesy */}
      <Modal
        show={modalCourtesy}
        onHide={handleCloseModalCourtesy}
        centered
        size="lg"
      >
        <Modal.Body>
          <div className="d-flex justify-content-between align-items-center mb-4 px-5">
            <h2 className="title mb-0">Gerar Cortesia</h2>
            <button
              type="button"
              className="border-0 bg-transparent"
              onClick={handleCloseModalCourtesy}
            >
              <KrClose size={20} color="#989898" />
            </button>
          </div>
          <div className="px-5 mb-4">
            <hr />
          </div>
          <Form
            ref={formRefCourtesy}
            onSubmit={handleSubmitCourtesy}
            className="px-5"
          >
            <div className="mb-3">
              <Input name="name" placeholder="Nome da Cortesia" />
            </div>

            <div className="mb-3">
              <Select
                name="event"
                options={eventsModal}
                placeholder="Selecione o evento"
                onChangeText={handleChangeTextEvent}
                value={eventName}
                onChange={(e: any) => handleSelectEvent(e)}
              />
              {erroEvent && (
                <p className="text-center text-danger">{erroEvent}</p>
              )}
            </div>
            {selectedEventId && modalities.length > 0 && (
              <div className="my-4">
                <h4 className="mb-4">Modalidades e Categorias</h4>
                {modalities.map((modality) => (
                  <ModalityContainer key={modality.id}>
                    <h5 className="h6 fw-semibold ">{modality.name}</h5>
                    {modality.categories.map((category) => {
                      const currentQty =
                        quantities[`${modality.id}-${category.id}`] || 0;
                      const isExceeded = currentQty > category.available;

                      return (
                        <CategoryItem key={category.id}>
                          <span className="category-name">
                            {category.name}{' '}
                            <span className="text-danger">
                              {category.available === 0 ? '(Esgotado)' : ''}
                            </span>
                          </span>
                          <div className="d-flex flex-column align-items-end pe-3">
                            <div className="input-wrapper">
                              <Input
                                name="quantity"
                                disabled={category.available === 0}
                                type="number"
                                className="form-control input-quantity"
                                placeholder="Qtd"
                                min="0"
                                onChange={(e) =>
                                  handleQuantityChange(
                                    modality.id,
                                    category.id,
                                    e.target.value
                                  )
                                }
                              />
                            </div>
                            {isExceeded && (
                              <span className="small text-danger mt-1 text-right">
                                Quantidade disponível ultrapassada (Máx:{' '}
                                {category.available})
                              </span>
                            )}
                          </div>
                        </CategoryItem>
                      );
                    })}
                    {erroQtdTicket && (
                      <p className="text-center text-danger mt-2">
                        {erroQtdTicket}
                      </p>
                    )}
                  </ModalityContainer>
                ))}
              </div>
            )}

            <div className="d-flex justify-content-end mt-5">
              <button
                type="submit"
                className="btn-filter text-white px-4 py-2"
                disabled={isAnyQuantityExceeded || submitting}
              >
                Salvar
              </button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Modal List Tickets */}
      <Modal
        show={modalList}
        onHide={() => setModalList(false)}
        centered
        size="xl"
      >
        <Modal.Body>
          <div className="d-flex justify-content-between align-items-center mb-4 px-4">
            <h2 className="title">{ticketList[0]?.event_name}: Inscrições</h2>
            <div className="d-flex align-items-center">
              <button
                type="button"
                className="border-0 bg-transparent"
                onClick={() => setModalList(false)}
              >
                <KrClose size={20} color="#989898" />
              </button>
            </div>
          </div>

          <TableListModal>
            <div className="content">
              <Table
                columns={columnsTickets}
                data={ticketList}
                className="py-0"
              />
              <div className="px-4">
                <button
                  type="button"
                  className="btn-new text-white mt-4 px-4 py-2 me-4"
                  onClick={handleOpenEmailAll}
                  disabled={
                    !isOrganizerOrder || ticketList.some((t) => !!t.email)
                  }
                  style={{
                    opacity:
                      !isOrganizerOrder || ticketList.some((t) => !!t.email)
                        ? 0.5
                        : 1,
                  }}
                >
                  Enviar conjunto
                </button>
              </div>
            </div>
          </TableListModal>
        </Modal.Body>
      </Modal>

      {/* Modal Send Email */}
      <Modal show={modalEmail} onHide={() => setModalEmail(false)}>
        <Modal.Body>
          <div className="d-flex justify-content-between align-items-center mb-4 px-4">
            <h2 className="title">Enviar Inscrição</h2>
            <button
              type="button"
              className="border-0 bg-transparent"
              onClick={() => setModalEmail(false)}
            >
              <KrClose size={20} color="#989898" />
            </button>
          </div>

          <Form
            ref={formRefEmail}
            onSubmit={handleSubmitEmail}
            className="px-4"
          >
            <div className="mb-3">
              <Input name="email" placeholder="Email do destinatário" />
            </div>

            <div className="d-flex justify-content-end mt-4">
              <button
                type="submit"
                className="btn-filter text-white px-4 py-2"
                disabled={loading}
              >
                Enviar
              </button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default Courtesy;
